<irembogov-phone-number
  [formControl]="formControl"
  ngDefaultControl
  [id]="field.key"
  [countryNoValidation]="
    field.props['countryNoValidation'] === undefined
      ? true
      : field.props['countryNoValidation']
  "
  [preferredCountries]="field.props['preferredCountries']"
  [allowDropdown]="field.props['allowDropdown']"
  [onlyCountries]="field.props['onlyCountries']"
  [initialCountry]="field.props['initialCountry']"
  [excludeCountries]="field.props['excludeCountries']"
  [allowedNumberTypes]="field.props['allowedNumberTypes']"
  [placeholder]="field.props['placeholder'] ? field.props['placeholder'] : ''"
  [countryCodeFromPhone]="countryCodeFromPhone"
  (intelInputInitialized)="
    intelInputInitialized($event)
  "></irembogov-phone-number>
